
class BrowserStorage {
  storage: Storage

  constructor(storage: Storage) {
    this.storage = storage
  }

  get<T = unknown>(key: string, now: number = Date.now()): T|undefined {
    try {
      const data = this.storage.getItem(key)

      if (!data) {
        return undefined
      }

      const { payload, createdAt, expiration } = JSON.parse(data)
      const MILLISECONDS_IN_SECOND = 1000

      if (expiration && now - createdAt > expiration * MILLISECONDS_IN_SECOND) {
        this.storage.removeItem(key)
        return undefined
      }

      return payload
    } catch (err) {
      return undefined
    }
  }

  set(
    key: string,
    data: unknown,
    expiration?: number,
    createdAt: number = Date.now()
  ): void {
    try {
      const serializedData = JSON.stringify({
        payload: data,
        expiration,
        createdAt,
      })
      this.storage.setItem(key, serializedData)
    } catch (error) {
      // ignore write errors
    }
  }
}

export default BrowserStorage
